







































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import SpFieldImg from '@/app/components/SpField/SpFieldImg.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import SpHeader from '@/app/components/Common/SpHeader.vue'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import Validator from '@/app/module/validator'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag, userType } from '@/app/model/store/domain/const'
/* api */
import GetImageApi from '@/app/model/api/getImageApi'
import UploadImgApi from '@/app/model/api/uploadImgApi'
import RecordDetailApi from '@/app/model/api/recordDetailApi'
import RecordCreateApi from '@/app/model/api/recordCreateApi'
import RecordEditApi from '@/app/model/api/recordEditApi'
import RecordDeleteApi from '@/app/model/api/recordDeleteApi'
import AccountListApi from '@/app/model/api/accountListApi'
import riskListApi from '@/app/model/api/riskListApi'
import FieldListApi from '@/app/model/api/fieldListApi'

@Component({
  components: {
    Loading,
    DeleteModal,
    SpFieldImg,
    SpHeader,
    Datepicker,
    Error409Modal,
    ErrorInfo
  }
})
export default class SpFieldDetails extends Vue {
  /* 表示切り替え */
  private showNotFound: boolean = false
  private showLoading: boolean = false
  private showPlantingDetails: boolean = true
  private isEdit: boolean = false
  private showDeleteModal: boolean = false
  private showAddRisk: boolean = false
  private showChangeMainImgModal: boolean = false
  private showAddImgModal: boolean = false
  private showHeaderMenu: boolean = true
  private getAccountFlag: boolean = false
  private getRiskFlag: boolean = false
  private getRecordFlag: boolean = false
  private showError409Modal: boolean = false
  private showStemNum: boolean = false
  private showStemNumM2: boolean = false
  private show400ErrorMessage: boolean = false
  private showImgErrorMessage: boolean = false

  /* datepicker */
  private japanese: any = ja
  private form: any = 'yyyy-MM-dd'
  /* データ */
  private errorMessages: any = []
  private alertText: string = ''
  private alertTitle: string = ''
  private temperatureDifference: number | string = ''
  private recordDate: number = 0
  private accountData: any = {}
  private riskData: any = {}
  private constantValue: any = {}
  private paddyFieldRisk: any = {
    risk_id: null,
    risk_item_id: null
  }
  private cultivationRisk: any = {
    risk_id: null,
    risk_item_id: null
  }
  private recordData: any = {
    planting: {
      record_date: '',
      record_user_name: '',
      record_user_id: null,
      remarks: '',
      point_icon: null
    },
    images: [],
    internal_factors: {
      stem_number: null,
      stem_number_m2: null,
      plant_height: null,
      stem_length: null,
      ear_length: null,
      leaf_age: null,
      spad: null
    },
    external_factors: {
      weather_name: '',
      temperature: null,
      temperature_highest: null,
      temperature_lowest: null,
      water_level: null,
      water_temperature: null,
      soil_temperature: null,
      solar_radiation: null,
      humidity: null,
      windy_time: null,
      wind_velocity: null,
      rainfall: null,
      soil_ph: null,
      soil_ec: null,
      ph: null
    },
    harvest_risks: []
  }
  private imgArray: any[] = []
  private beforeChangeMainImg: any[] = []
  private submittedArticle: any = {
    title: '',
    image: null
  }
  private newImg: any[] = []
  private editImg: any[] = []
  private files: any[] = []
  private beforeEdirImgCropIds: any[] = []
  private pointIconImgs: any = [
    {
      value: 1,
      img: require('@/assets/icon/aisaku_camera_icon.svg')
    },
    {
      value: 2,
      img: require('@/assets/icon/black_star_icon.svg')
    },
    {
      value: 3,
      img: require('@/assets/icon/star_icon.svg')
    },
    {
      value: 4,
      img: require('@/assets/icon/exclamation_mark_icon.svg')
    }
  ]

  private get accountDataFlag (): any {
    return this.getAccountFlag
  }
  @Watch('accountDataFlag')
  getAccountData (flag: boolean) {
    if (flag && this.getRecordFlag && this.getRiskFlag && this.isEdit) {
      this.recordData.planting.record_user_id = this.getAccountId(this.recordData.planting.record_user_name)
      this.recordData.external_factors.weather_id = this.getWeatherId(this.recordData.external_factors.weather_name)
    }
  }

  private get riskDataFlag (): any {
    return this.getRiskFlag
  }
  @Watch('riskDataFlag')
  getRiskData (flag: boolean) {
    if (flag && this.getAccountFlag && this.getRecordFlag && this.isEdit) {
      this.recordData.planting.record_user_id = this.getAccountId(this.recordData.planting.record_user_name)
      this.recordData.external_factors.weather_id = this.getWeatherId(this.recordData.external_factors.weather_name)
    }
  }

  private get recordDataFlag (): any {
    return this.getRecordFlag
  }
  @Watch('recordDataFlag')
  getRecordData (flag: boolean) {
    if (flag && this.getAccountFlag && this.getRiskFlag && this.isEdit) {
      this.recordData.planting.record_user_id = this.getAccountId(this.recordData.planting.record_user_name)
      this.recordData.external_factors.weather_id = this.getWeatherId(this.recordData.external_factors.weather_name)
    }
  }

  @Watch('recordData.planting.record_date', { deep: true })
  private onChangeRecordDate (newChangeDate: any) {
    if (!this.isEdit) {
      this.recordDateCheck(newChangeDate)
    }
  }

  private setDifference () {
    if (this.recordData.external_factors.temperature_highest && this.recordData.external_factors.temperature_lowest &&
        this.recordData.external_factors.temperature_highest >= this.recordData.external_factors.temperature_lowest) {
      this.temperatureDifference = this.calcSubtract(this.recordData.external_factors.temperature_highest, this.recordData.external_factors.temperature_lowest)
    } else {
      this.temperatureDifference = ''
    }
  }

  private getDotPosition (value: any) {
    let strVal = String(value)
    let dotPosition = 0
    if (strVal.lastIndexOf('.') !== -1) {
      dotPosition = (strVal.length - 1) - strVal.lastIndexOf('.')
    }
    return dotPosition
  }

  private calcSubtract (valueHighest: any, valueLowest: any) {
    // それぞれの小数点の位置を取得
    let dotPositionHighest = this.getDotPosition(valueHighest)
    let dotPositionLowest = this.getDotPosition(valueLowest)

    if (dotPositionHighest >= 2 || dotPositionLowest >= 2 || parseInt(valueHighest) > 200 || parseInt(valueLowest) > 200 || parseInt(valueHighest) < -20 || parseInt(valueLowest) < -20) {
      // 小数点第２以上が入力されている時は計算しない
      return ''
    }

    // 位置の値が大きい方（小数点以下の位が多い方）の位置を取得
    let max = Math.max(dotPositionHighest, dotPositionLowest)

    // 大きい方に小数の桁を合わせて文字列化、
    // 小数点を除いて整数の値にする
    let intValueHighest = parseInt((valueHighest.toFixed(max) + '').replace('.', ''))
    let intValueLowest = parseInt((valueLowest.toFixed(max) + '').replace('.', ''))

    // 10^N の値を計算
    let power = Math.pow(10, max)

    // 整数値で引き算した後に10^Nで割る
    return (intValueHighest - intValueLowest) / power
  }

  private recordDateCheck (date: any) {
    (async () => {
      // カレンダーから選択された日付を取得
      const recordDate = this.createYYYYmmdd(date)
      // 詳細取得
      const result = await RecordDetailApi.getRecordDetail(this.$route.params.plant_id, recordDate)
      const elRecordDate: any = document.getElementById('recordDate')!
      // すでに登録済みの記録日であればエラー
      if (result.isOk()) {
        elRecordDate.innerText = '指定日の生育記録は、すでに登録されています。'
        // アンカーオブジェクトを作成
        var anchor = document.createElement('a')
        // ハイパーリンク先を指定
        anchor.href = '/sp/field/' + this.$route.params.field_id + '/' + this.$route.params.plant_id + '/record/' + recordDate
        anchor.innerText = '指定日の生育記録 >'
        elRecordDate.appendChild(anchor)
      } else {
        elRecordDate.innerText = ''
      }
    })()
  }

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    if (this.$route.name === '作付け生育記録編集・削除') {
      this.recordDate = parseInt(this.$route.params.record_date)
      this.$store.commit('spFieldState/setBeforeRecordDate', this.recordDate)
      this.isEdit = true
      this.getAccountList()
      this.getRiskList()
      this.getPlantingRecords()
    } else {
      // 茎数表示切替
      this.$store.commit('spFieldState/setBeforeRecordDate', 1)
      this.getFieldData()
      this.isEdit = false
      this.getAccountList()
      this.getRiskList()
      this.setLoginUserToRecord()
    }
  }

  /* データ取得 */
  private async getFieldData () {
    const data = {
      order_num: 2,
      word: '',
      variety_id: 0,
      grade_id: 0,
      growth_stage_id: 0,
      risk_id: 0,
      planting_id: parseInt(this.$route.params.plant_id),
      is_polygon: 1,
      is_field: 1
    }

    const result = await FieldListApi.getFieldData(this.$store.state.fieldState.plantingOnly, '1', data)

    if (result.isOk()) {
      if (result.getPayload().field_list.length === 0) {
        // 権限エラー(404ページへ遷移)
        this.$store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_DEFAULT)
        this.$router.push(routerPath.PATH_SP_ERROR_PAGE).catch(e => {})
      } else {
        const plantData = result.getPayload().field_list[0]
        const plantingId = parseInt(this.$route.params.plant_id)
        if (plantData.stem_number_type === 1 || plantData.stem_number_type === 3) {
          this.showStemNum = true
        }
        if (plantData.stem_number_type === 2 || plantData.stem_number_type === 3) {
          this.showStemNumM2 = true
        }
      }
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'GET', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  // 画像系
  private onImageUploaded (e: any) {
    if (e.target.files[0].type === 'image/png' ||
        e.target.files[0].type === 'image/jpeg') {
      this.showImgErrorMessage = false
      this.files.push(e.target.files[0])
      const image = e.target.files[0]
      this.submittedArticle.title = image.name
      this.createImage(image)
    } else {
      this.alertTitle = '許可されている拡張子ではありません。（登録できる拡張子は、.jpeg、.jpg、.pngです）'
      this.showImgErrorMessage = true
    }
  }

  private createImage (image: any) {
    const reader = new FileReader()
    reader.readAsDataURL(image)
    reader.onload = () => {
      this.submittedArticle.image = reader.result
    }
  }

  private doCancelAddImg () {
    this.showAddImgModal = false
    this.showHeaderMenu = true
    this.submittedArticle.image = null
    this.showImgErrorMessage = false
  }

  private doAddImg () {
    this.showImgErrorMessage = false
    this.showAddImgModal = false
    this.showHeaderMenu = true
    let isMain
    if (this.submittedArticle.image !== null) {
      // 画像が1件しかない場合は自動でメイン画像にする
      if (this.imgArray.length === 0) {
        isMain = 1
      } else {
        isMain = 0
      }
      this.imgArray.push({
        image: this.submittedArticle.image,
        name: this.submittedArticle.title,
        planting_id: this.$route.params.plant_id,
        record_date: 0,
        crop_image_id: 0,
        is_main: isMain
      })
    }
    // 画像追加モーダル初期化
    this.submittedArticle.image = null
  }

  private doDeleteImg (key: number) {
    if (this.imgArray[key].is_main === 1 && this.imgArray.length !== 1) {
      this.alertText = ''
      this.alertTitle = 'メイン画像は削除できません。メイン画像を変更してから削除してください。'
      this.show400ErrorMessage = true
    } else {
      this.imgArray.splice(key, 1)
    }
  }

  private doShowChangeMainImg () {
    const array = []
    for (let i in this.imgArray) {
      array.push({
        crop_image_id: this.imgArray[i].crop_image_id,
        image: this.imgArray[i].image,
        is_main: this.imgArray[i].is_main,
        name: this.imgArray[i].name,
        record_date: this.imgArray[i].record_date,
        planting_id: this.imgArray[i].planting_id
      })
    }
    this.beforeChangeMainImg = array
    this.showChangeMainImgModal = true
    this.showHeaderMenu = false
  }

  private cancelChangeMainImg () {
    this.beforeChangeMainImg = []
    this.showChangeMainImgModal = false
    this.showHeaderMenu = true
  }

  private saveChangeMainImg () {
    this.imgArray = this.beforeChangeMainImg
    this.showChangeMainImgModal = false
    this.showHeaderMenu = true
  }

  private changeMainImg (key: number) {
    for (let i in this.beforeChangeMainImg) {
      if (parseInt(i) === key) {
        this.beforeChangeMainImg[i].is_main = 1
      } else {
        this.beforeChangeMainImg[i].is_main = 0
      }
    }
  }

  // リスク
  private addRisk () {
    if (this.paddyFieldRisk.risk_id !== null) {
      let paddyFieldRisk = this.getRiskName(this.paddyFieldRisk.risk_id, this.paddyFieldRisk.risk_item_id)
      this.recordData.harvest_risks.push({
        risk_id: this.paddyFieldRisk.risk_id,
        risk_name: paddyFieldRisk.risk_name,
        risk_item_id: this.paddyFieldRisk.risk_item_id,
        risk_item_name: paddyFieldRisk.risk_item_name
      })
    }
    if (this.cultivationRisk.risk_id !== null) {
      let cultivationRisk = this.getRiskName(this.cultivationRisk.risk_id, this.cultivationRisk.risk_item_id)
      this.recordData.harvest_risks.push({
        risk_id: this.cultivationRisk.risk_id,
        risk_name: cultivationRisk.risk_name,
        risk_item_id: this.cultivationRisk.risk_item_id,
        risk_item_name: cultivationRisk.risk_item_name
      })
    }
    // 初期化
    this.paddyFieldRisk = {
      risk_id: null,
      risk_item_id: null
    }
    this.cultivationRisk = {
      risk_id: null,
      risk_item_id: null
    }
    this.showAddRisk = false
    this.showHeaderMenu = true
  }

  private displayFieldRisk (key: string) {
    // 既に選択されているリスク名は表示しない
    let data = []
    let selectedRisk = []
    for (let i in this.recordData.harvest_risks) {
      selectedRisk.push(this.recordData.harvest_risks[i].risk_id)
    }
    if (key === 'isConstant') {
      for (let j in this.riskData) {
        if (this.riskData[j].is_constant_risk && !selectedRisk.includes(this.riskData[j].harvest_risk_id)) {
          data.push(this.riskData[j])
        }
      }
    } else {
      for (let j in this.riskData) {
        if (!this.riskData[j].is_constant_risk && !selectedRisk.includes(this.riskData[j].harvest_risk_id)) {
          data.push(this.riskData[j])
        }
      }
    }
    return data
  }

  private cancelAddLisk () {
    // 初期化
    this.paddyFieldRisk = {
      risk_id: null,
      risk_item_id: null
    }
    this.cultivationRisk = {
      risk_id: null,
      risk_item_id: null
    }
    this.showAddRisk = false
    this.showHeaderMenu = true
  }

  private getRiskItem (riskId: number) {
    let data
    if (riskId === null || riskId === undefined) {
      data = [{
        risk_item_id: '',
        risk_item_name: ''
      }]
      return data
    } else {
      data = this.riskData.filter(function (value: any) {
        if (value.harvest_risk_id === riskId) {
          return value
        }
      })
      return data[0].harvest_risk_items
    }
  }

  private doDeleteRisk (key: number) {
    this.recordData.harvest_risks.splice(key, 1)
  }

  private getRiskName (riskId: number, riskItemId: number) {
    const data = this.riskData.filter(function (value: any) {
      if (value.harvest_risk_id === riskId) {
        return value
      }
    })
    const itemData = data[0].harvest_risk_items.filter(function (value: any) {
      if (value.risk_item_id === riskItemId) {
        return value
      }
    })

    // リスク項目は空OKなので無い場合は空をセット
    if (itemData.length === 0) {
      itemData.push({
        risk_item_name: ''
      })
    }

    const names = {
      risk_name: data[0].harvest_risk_name,
      risk_item_name: itemData[0].risk_item_name
    }
    return names
  }

  private setLoginUserToRecord () {
    if (this.getAccountId(this.recordData.planting.record_user_name) > 0) {
      return
    }
    this.recordData.planting.record_user_id = Number(Local.getUserId()!)
    this.recordData.planting.record_user_name = Local.getUserName()!
  }

  private getAccountId (accountName: string) {
    for (let i in this.accountData) {
      if (this.accountData[i].name === accountName) {
        return this.accountData[i].user_id
      }
    }
  }

  private getWeatherId (weatherName: string) {
    for (let i in this.constantValue.weathers) {
      if (this.constantValue.weathers[i].weather_name === weatherName) {
        return this.constantValue.weathers[i].weather_id
      }
    }
  }

  // 半角数字、-、.以外入力制限
  private inputCheck (key1: string, key2: string) {
    let before = String(this.recordData[key1][key2])

    let tmp
    let after: any
    if (before === null) {
      after = null
    } else {
      tmp = before.replace(/[^-.0-9]/g, '')
      tmp = tmp.split('').reverse().join('')
      tmp = tmp.replace(/-(?=.)|\.(?=.*\.)/g, '')
      after = tmp.split('').reverse().join('')
    }

    if (isNaN(parseFloat(after))) {
      this.recordData[key1][key2] = null
    } else {
      this.recordData[key1][key2] = parseFloat(after)
    }

    if (key2 === 'temperature_highest' || key2 === 'temperature_lowest') {
      this.setDifference()
    }
  }

  private getPlantingRecords () {
    (async () => {
      const result = await RecordDetailApi.getRecordDetail(this.$route.params.plant_id, this.recordDate)
      if (result.isOk()) {
        this.recordData = result.getPayload()
        let array = []
        for (let i in this.recordData.images) {
          this.recordData.images[i].image = '0'
          this.recordData.images[i].record_date = this.recordDate
          array.push(this.recordData.images[i].crop_image_id)
        }
        // 茎数表示切替
        if (this.recordData.planting.stem_number_type === 1 || this.recordData.planting.stem_number_type === 3) {
          this.showStemNum = true
        }
        if (this.recordData.planting.stem_number_type === 2 || this.recordData.planting.stem_number_type === 3) {
          this.showStemNumM2 = true
        }

        this.setDifference()
        this.recordData.external_factors.temperature_difference = null
        this.beforeEdirImgCropIds = array
        this.imgArray = this.recordData.images
        this.getRecordFlag = true
        this.setLoginUserToRecord()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  private getRiskList () {
    (async () => {
      /* 初期表示は名前の昇順 */
      const data = {
        word: '',
        order_name: 'harvest_risk_name',
        sort: true
      }

      const result = await riskListApi.getRiskList(data)

      if (result.isOk()) {
        this.riskData = result.getPayload().results
        this.riskData[0].is_constant_risk = false
        this.getRiskFlag = true
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  // 生産者情報取得
  private getAccountList () {
    (async () => {
      const data = {
        type: 0,
        text: '',
        num: 2,
        sort: 'asc'
      }

      const result = await AccountListApi.getAccountList(data)

      if (result.isOk()) {
        if (result.getPayload().total_user === 0) {
          this.alertText = ''
          this.alertTitle = '生産者が未登録です。生産者を登録してから作付けを追加してください。'
          this.show400ErrorMessage = true
        } else {
          this.accountData = result.getPayload().users
          this.getAccountFlag = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  private doPlantDelete () {
    (async () => {
      this.showLoading = true
      const result = await RecordDeleteApi.doRecordDelete(this.$route.params.plant_id, this.$route.params.record_date)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', '作付け記録を削除しました。')
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/sp/field/' + this.$route.params.field_id + '/' + this.$route.params.plant_id)
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showDeleteModal = false
      this.showLoading = false
    })()
  }

  private getImgFile (imgName: string) {
    for (let i in this.files) {
      if (imgName === this.files[i].name) {
        return this.files[i]
      }
    }
  }

  private doSave () {
    /* バリデーションチェック */
    if (!this.isRecordValidate()) {
      // 上までスクロール
      const plantingDetail: any = document.getElementById('plantingDetail')!
      plantingDetail.scrollTop = 0
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }
    this.showLoading = true

    if (this.isEdit) {
      const defultImg = []
      const newImg = []
      const editImg = []
      for (let i in this.imgArray) {
        if (this.imgArray[i].crop_image_id === 0) {
          newImg.push({
            name: this.imgArray[i].name,
            planting_id: parseInt(this.$route.params.plant_id),
            is_main: this.imgArray[i].is_main,
            record_date: parseInt(this.$route.params.record_date)
          })
        } else {
          defultImg.push(this.imgArray[i].crop_image_id)
        }
      }

      let editImgIsMain = false
      for (let j in this.beforeEdirImgCropIds) {
        if (defultImg.includes(this.beforeEdirImgCropIds[j])) {
          for (let i in this.imgArray) {
            if (this.beforeEdirImgCropIds[j] === this.imgArray[i].crop_image_id) {
              if (this.imgArray[i].is_main === 1) {
                // 編集画像内にメインがあるか確認
                editImgIsMain = true
              }
              editImg.push({
                crop_image_id: this.imgArray[i].crop_image_id,
                is_main_image: this.imgArray[i].is_main,
                is_delete_flag: 0
              })
            }
          }
        } else {
          editImg.push({
            crop_image_id: this.beforeEdirImgCropIds[j],
            is_main_image: 0,
            is_delete_flag: 1
          })
        }
      }
      // 新規画像がメインの場合、編集画像の1つにメインフラグをたてる
      if (editImg.length !== 0 && !editImgIsMain) {
        editImg[0].is_main_image = 1
      }
      this.newImg = newImg
      this.editImg = editImg
      this.recordEdit()
    } else {
      this.recordCreate()
    }
  }

  /* カンマ区切りにする */
  private toLocaleString (num: number) {
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }

  private isRecordValidate () {
    for (let i in this.errorMessages) {
      this.errorMessages[i] = ''
    }
    const userNameFlag = Validator.validateInputUserName('userNameErrorMessage', this.recordData.planting.record_user_id)
    this.errorMessages = Validator.getErrorMessage()

    let recordDateFlag = true
    const elRecordDate: any = document.getElementById('recordDate')!
    if (this.recordData.planting.record_date === '') {
      this.$set(this.errorMessages, 'recordDateErrorMessage', '記録日は必ず入力してください。')
      recordDateFlag = false
    }

    let internalFactorFlag = true
    for (let i in this.recordData.internal_factors) {
      let maxValue = 200
      if (i === 'stem_number_m2') {
        maxValue = 4000
      }
      let data = this.recordData.internal_factors[i]
      let decimalPointLength = String(data).split('.')
      const numberOfDecimals = i === 'leaf_age' ? 2 : 1
      if (data < 0 || data > maxValue) {
        this.$set(this.errorMessages, i, '0以上' + this.toLocaleString(maxValue) + '以下の範囲で入力してください。')
        internalFactorFlag = false
      } else if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > numberOfDecimals) {
        this.$set(this.errorMessages, i, `小数点第${numberOfDecimals}位までの範囲で入力してください。`)
        internalFactorFlag = false
      }
    }
    let externalFactorFlag = true
    for (let i in this.recordData.external_factors) {
      let data = this.recordData.external_factors[i]
      let maxValue = 200
      let minValue = 0
      if (i === 'temperature' || i === 'temperature_highest' || i === 'temperature_lowest') {
        minValue = -20
      }
      let decimalPointLength = String(data).split('.')
      if (data < minValue || data > maxValue) {
        this.$set(this.errorMessages, i, minValue + '以上' + maxValue + '以下の範囲で入力してください。')
        externalFactorFlag = false
      } else if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
        this.$set(this.errorMessages, i, '小数点第1位までの範囲で入力してください。')
        internalFactorFlag = false
      }
      if (i === 'temperature_highest') {
        if (this.recordData.external_factors.temperature_highest < this.recordData.external_factors.temperature_lowest) {
          this.$set(this.errorMessages, i, '-20以上200以下かつ最低気温(℃)以上の範囲で入力してください。')
          externalFactorFlag = false
        }
      }
      if (i === 'temperature_lowest') {
        if (this.recordData.external_factors.temperature_highest < this.recordData.external_factors.temperature_lowest) {
          this.$set(this.errorMessages, i, '-20以上200以下かつ最高気温(℃)以下の範囲で入力してください。')
          externalFactorFlag = false
        }
      }
    }
    return userNameFlag && internalFactorFlag && externalFactorFlag && recordDateFlag
  }

  private async recordCreate () {
    const body: any = {
      external_factors: this.recordData.external_factors,
      harvest_risks: this.recordData.harvest_risks,
      images: [],
      internal_factors: this.recordData.internal_factors,
      planting: {
        record_date: this.createYYYYmmdd(this.recordData.planting.record_date),
        record_user_id: this.recordData.planting.record_user_id,
        remarks: this.recordData.planting.remarks,
        point_icon: this.recordData.planting.point_icon
      }
    }
    const result = await RecordCreateApi.doRecordCreate(body, this.$route.params.plant_id)

    if (result.isOk()) {
      // 画像を登録
      for (let i in this.imgArray) {
        this.imgArray[i].record_date = this.createYYYYmmdd(this.recordData.planting.record_date)
        await this.uploadImg(this.imgArray[i])
      }
      this.$router.push('/sp/field/' + this.$route.params.field_id + '/' + this.$route.params.plant_id + '/record/' + this.createYYYYmmdd(this.recordData.planting.record_date)).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async uploadImg (data: any) {
    let body: any = {
      image: this.getImgFile(data.name),
      planting_id: parseInt(data.planting_id),
      record_date: data.record_date,
      is_main: data.is_main
    }
    const result = await UploadImgApi.getUploadImg(body)

    if (result.isOk()) {
      // 200
    } else if (result.getPayload().status_code === '400') {
      let errors: any = []
      for (var i in result.getPayload().errors) {
        if (result.getPayload().errors[i].code === '30101EV008') {
          errors.push('画像の登録に失敗しました。（登録できる拡張子は、.jpeg、.jpg、.pngです）')
        } else {
          errors.push(result.getPayload().errors[i].message)
        }
      }
      this.$store.commit('alertState/setErrorAlertMessage', errors.join('<br/>'))
      this.$store.commit('alertState/setErrorAlertFlag', true)
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async recordEdit () {
    const body = {
      external_factors: this.recordData.external_factors,
      harvest_risks: this.recordData.harvest_risks,
      images: this.editImg,
      internal_factors: this.recordData.internal_factors,
      planting: this.recordData.planting
    }
    const result = await RecordEditApi.doRecordEdit(body, this.$route.params.plant_id, parseInt(this.$route.params.record_date))

    if (result.isOk()) {
      if (this.newImg.length !== 0) {
        for (let j in this.newImg) {
          await this.uploadImg(this.newImg[j])
        }
        this.$store.commit('alertState/setAlertMessage', '作付け記録編集が完了しました。')
        this.$store.commit('alertState/setAlertFlag', true)
      }
      this.$router.push('/sp/field/' + this.$route.params.field_id + '/' + this.$route.params.plant_id + '/record/' + parseInt(this.$route.params.record_date)).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private dateToStringYmd (date: any) {
    if (date !== '' && this.isEdit) {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '年' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '月' + DateClass.toDoubleDigits(updateDate.getDate()) + '日'
      return formingDate
    }
  }

  private createYYYYmmdd (e: any) {
    if (String(e).length === 8) {
      return e
    } else {
      const year = String(e.getFullYear())
      const month = '0' + String(e.getMonth() + 1)
      const day = '0' + String(e.getDate())
      return parseInt(year + month.slice(-2) + day.slice(-2))
    }
  }

  private doCancel () {
    if (this.isEdit) {
      this.$router.push('/sp/field/' + this.$route.params.field_id + '/' + this.$route.params.plant_id + '/record/' + parseInt(this.$route.params.record_date))
    } else {
      this.$router.push('/sp/field/' + this.$route.params.field_id + '/' + this.$route.params.plant_id)
    }
  }
}
